import * as React from 'react';

export const inFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_413)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_413'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_413)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 13.3333H28V20H0V13.3333Z'
                    fill='#249F58'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M14 13.3333C15.84 13.3333 17.3333 11.84 17.3333 10C17.3333 8.16 15.84 6.66667 14 6.66667C12.16 6.66667 10.6667 8.16 10.6667 10C10.6667 11.84 12.16 13.3333 14 13.3333ZM14 12C15.104 12 16 11.104 16 10C16 8.896 15.104 8.00001 14 8.00001C12.896 8.00001 12 8.896 12 10C12 11.104 12.896 12 14 12Z'
                    fill='#07038D'
                />
                <path
                    d='M14 10.6667C14.3682 10.6667 14.6667 10.3682 14.6667 9.99999C14.6667 9.63181 14.3682 9.33333 14 9.33333C13.6318 9.33333 13.3333 9.63181 13.3333 9.99999C13.3333 10.3682 13.6318 10.6667 14 10.6667Z'
                    fill='#07038D'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0 0H28V6.66667H0V0Z'
                    fill='#FF6820'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_413'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
